import { hasItems } from "~/features/app/utils";
import { PartnerGalleryDesktopView } from "./desktop";
import { PartnerGalleryMobileView } from "./mobile";
import type { PartnerGalleryLayoutProps, PartnerGalleryViewItem } from "./shared";
export type PartnerGalleryBlockViewProps = Omit<PartnerGalleryLayoutProps, "items"> & {
  items?: PartnerGalleryViewItem[] | null;
};
export function PartnerGalleryBlockView({
  anchor,
  hasTopDivider,
  isHighlighted = false,
  items = [],
  mode = "light",
  sectionProps,
  showGalleryNavigation = false
}: PartnerGalleryBlockViewProps) {
  const galleryItems = items ?? [];
  if (!hasItems(galleryItems)) {
    return null;
  }
  return <>
      <PartnerGalleryDesktopView anchor={anchor} items={galleryItems} mode={mode as string} hasTopDivider={hasTopDivider as boolean} isHighlighted={isHighlighted} sectionProps={sectionProps} showGalleryNavigation={showGalleryNavigation} />
      <PartnerGalleryMobileView anchor={anchor} items={galleryItems} mode={mode as string} hasTopDivider={hasTopDivider as boolean} isHighlighted={isHighlighted} sectionProps={sectionProps} showGalleryNavigation={showGalleryNavigation} />
    </>;
}